import { Illustration, Title } from "@clipboard-health/ui-components";

export default function ErrorComponent() {
  return (
    <>
      <Illustration type="error" />
      <Title
        component="h6"
        variant="h6"
        sx={(theme) => ({
          color: theme.palette.text.secondary,
          marginTop: 10,
        })}
        align="center"
      >
        Something went wrong. Please try again.
      </Title>
    </>
  );
}
